import { render, staticRenderFns } from "./ButtonReq.vue?vue&type=template&id=6a2a5b77"
import script from "./ButtonReq.vue?vue&type=script&lang=js"
export * from "./ButtonReq.vue?vue&type=script&lang=js"
import style0 from "./ButtonReq.vue?vue&type=style&index=0&id=6a2a5b77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports